import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeroSection } from '../components/HeroSection';
import { TripForm, TripDetails } from '../components/TripForm';
import { RecommendationsPanel } from '../components/RecommendationsPanel';
type AppState = 'idle' | 'loading' | 'results';
export function HomePage() {
  const [appState, setAppState] = useState<AppState>('idle');
  const [tripDetails, setTripDetails] = useState<TripDetails | null>(null);
  const handleFormSubmit = (details: TripDetails) => {
    setTripDetails(details);
    setAppState('loading');
    // Simulate API call / curation process
    setTimeout(() => {
      setAppState('results');
      // Scroll to results smoothly
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 1500);
  };
  const handleReset = () => {
    setAppState('idle');
    setTripDetails(null);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <main className="min-h-screen bg-cream-100 flex flex-col" data-id="element-169">
      <AnimatePresence mode="wait" data-id="element-170">
        {appState !== 'results' && <motion.div key="hero-section" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0,
        overflow: 'hidden'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-171">
            <HeroSection data-id="element-172" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-10 pb-24" data-id="element-173">
              <TripForm onSubmit={handleFormSubmit} isLoading={appState === 'loading'} data-id="element-174" />
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Loading State Overlay */}
      <AnimatePresence data-id="element-175">
        {appState === 'loading' && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm" data-id="element-176">
            <div className="flex flex-col items-center" data-id="element-177">
              <div className="relative w-16 h-16" data-id="element-178">
                <motion.div animate={{
              rotate: 360
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute inset-0 rounded-full border-t-2 border-r-2 border-gold-400" data-id="element-179" />
                <motion.div animate={{
              rotate: -360
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute inset-2 rounded-full border-b-2 border-l-2 border-cream-100/50" data-id="element-180" />
              </div>
              <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="mt-6 text-gold-400 font-serif text-xl tracking-wider" data-id="element-181">
                Curating Your Experience...
              </motion.p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Results Panel */}
      <AnimatePresence data-id="element-182">
        {appState === 'results' && tripDetails && <motion.div key="results-section" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex-grow flex flex-col pt-8 pb-24" data-id="element-183">
            {/* Mini Header for Results Page */}
            <header className="w-full bg-black py-6 px-4 sm:px-6 lg:px-8 mb-8 shadow-md" data-id="element-184">
              <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-185">
                <h1 className="text-xl font-serif text-gold-400" data-id="element-186">
                  Seetaluxuryescape
                </h1>
                <div className="text-right text-sm text-cream-100/70 hidden sm:block" data-id="element-187">
                  <p data-id="element-188">
                    {tripDetails.departureDate} — {tripDetails.returnDate}
                  </p>
                </div>
              </div>
            </header>

            <RecommendationsPanel destination={tripDetails.destination} resort={tripDetails.resort} departureDate={tripDetails.departureDate} returnDate={tripDetails.returnDate} onReset={handleReset} data-id="element-189" />
          </motion.div>}
      </AnimatePresence>
    </main>;
}